/**
 * This module is in charge of building the main widget structure.
 */
(function() {

  "use strict";
  define('fg-arv/components/autocomplete',['fg-arv/constants', 'fg-arv/utils', 'fg-arv/google-helper'], function(constants, utils, googleHelper) {



    var PLACES_FILTER_THRESHOLD = {
      min: 4,
      max: Number.MAX_VALUE
    };


    var MAX_PLACES = 10;


    /**
     * Initializes an instance of the AutocompleteWidget class.
     * @param {} The element that will be enriched with autocompletion capabilities.
     * @param {MapWidget} The widget this autocomplete control is created within
     */
    var AutocompleteWidget = function(component, widget) {
      this._widget = widget;
      this._apiObject = widget.apiObject;

      var that = this;
      this._autocomplete = component.getElement().autocomplete({
        minChars: 0,
        triggerSelectOnValidInput: false,
        autoSelectFirst: false,
        noCache: true,
        preventBadQueries: false,
        width: 'auto', //before 250
        // groupBy: "groupName", // Suggestion objects' data fields must have a "groupName" field in order to be grouped.
        formatResult: function(suggestion, currentValue) {
          return that._formatResult(suggestion, currentValue);
        },
        lookup: function(query, done) {
          component.setLatLon(null);
          return that._lookup(query, done);
        },
        onSelect: function(suggestion) {
          // suggestion.data contains an object with the required signature {name: "<string>", coordinates:{lat:{number}, lng:{number}}}

          component.focus();
          if (jQuery.isFunction(suggestion.data.coordinates)) {
            // We retrieve the location for the selected
            suggestion.data.coordinates().done(function(location) {
              component.setLatLon(location);
              suggestion.data.coordinates = location;
              that._widget.triggerEvent(constants.events.locationSelected, suggestion.data);
            });
          } else {
            that._widget.triggerEvent(constants.events.locationSelected, suggestion.data);
          }
        }

      });
      component.getElement().blur = function() {
        var widgetDom = jQuery(that._widget.elementSelector);
        if (widgetDom) {
          widgetDom.find('.autocomplete-suggestions').hide();
        }
      };
    };

    jQuery.extend(AutocompleteWidget.prototype, {
      _formatResult: function(suggestion, currentValue) {
        var htmlSafeString = suggestion.value
          // .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');

        var pattern = '(' + jQuery.ui.autocomplete.escapeRegex(currentValue) + ')';

        return '<span class="fg-arv-suggestion-label" title="' + htmlSafeString + '">' + htmlSafeString.replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>') + '</span>';
      },
      _lookup: function(query, done) {
        if (this._lookupTimeout) {
          clearTimeout(this._lookupTimeout);
        }

        var that = this;
        this._lookupTimeout = setTimeout(function() {
          that._doLookup(query, done);
        }, 200);

      },
      _doLookup: function(query, done) {

        //We remove the error if exist
        var input = this._autocomplete;
        var from;
        if (input.hasClass('from')) {
          from = true;
        } else if (input.hasClass('to')) {
          from = false;
        }

        // We need to store an array of deferred objects so we are able to mix results from several sources
        // into a single suggestions array. Some source are only avalaible in some cases, so we cannot expect them
        // individually and need to store the aray.
        var deferreds = [];

        deferreds.push(this._getPlaces(query));

        // Here we abuse a little the prototype of jQuery's when method so we can pass it the deferreds array.
        jQuery.when.apply(jQuery, deferreds).done(function() {
          var suggestions = [];
          // Suggestions for individual sources (current location, places, favorites, etc.)
          // come as a function argument each. As we pass a dynamic number of arguments to the when method,
          // we cannot name each paramenter, so we use the arguments array.
          for (var i = 0; i < arguments.length; i++) {
            suggestions = suggestions.concat(arguments[i]);
          }

          // If there are no suggestion we show the error and close the suggestion box
          if (!suggestions.length && query.length >= PLACES_FILTER_THRESHOLD.min) {
            jQuery(input).openFGValidation();
          } else {
            jQuery(input).closeFGValidation();
          }

          done({
            suggestions: suggestions
          });

        });
      },


      _getPlaces: function(query) {
        var placesDef = jQuery.Deferred();

        if (query.length < PLACES_FILTER_THRESHOLD.min || query.length > PLACES_FILTER_THRESHOLD.max) {
          placesDef.resolve([]);
          return placesDef.promise();
        }

        var that = this;

        googleHelper.getPlacesPredictions(query, that._widget.map).done(function(places) {

            // We limit the shown results.
            places = places.slice(0, MAX_PLACES);

            // We convert favorite stations to autocomplete suggestion objects.
            var suggestions = [];
            for (var i = 0; i < places.length; i++) {

              suggestions.push({
                data: jQuery.extend(places[i], {
                  groupName: "Google Places:"
                }),
                value: places[i].name
              });
            }
            placesDef.resolve(suggestions);
          })
          .fail(function(status) {
            placesDef.reject(status);
          });

        return placesDef.promise();
      }


    });



    return {
      /**
       * Initializes an instance of the autocomplete widget given a selector.
       * @param component the LocationInput componet the autocomplete will be attached to.
       * @param widget the widget.
       */
      addAutocomplete: function(component, widget) {
        return new AutocompleteWidget(component, widget);
      }
    };
  });

})();
